import React from 'react'
import Svg from '../../atoms/Svg/Svg'
import styles from './NoContent.module.scss'

interface NoContentProps {
  heading?: React.ReactNode
  subHeading?: React.ReactNode
}

const NoContent = ({ heading, subHeading }: NoContentProps) => {
  return (
    <div className={styles.root}>
      <Svg name="no-content-graphic" />
      {heading && <h3>{heading}</h3>}
      {subHeading && <p>{subHeading}</p>}
    </div>
  )
}

export default NoContent
